export const UPSELL = "upsell product"
export const ADD_TO_CART = "add to cart"
export const PREVIEW = "preview"
